import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LearningResource } from '../search-view';

@Component({
  selector: 'dgx-search-endorsed-results',
  templateUrl: './search-endorsed-results.component.html',
  styleUrls: ['./search-endorsed-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchEndorsedResultsComponent implements OnInit {
  @Input() public results: LearningResource[];
  @Input() public isLoading: boolean;
  @Input() public mayLoadEndorsedContent: boolean;

  @Output() public loadEndorsedContent = new EventEmitter<void>();

  public i18n: Record<string, string>;

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    this.i18n = this.translateService.instant([
      'Core_Loading',
      'Core_LoadMore',
    ]);
  }
}
